import React from 'react';
import { Tag, Tooltip } from 'src/components/matchbox';
import useUniqueId from 'src/hooks/useUniqueId';
import { EXPIRED_DISPLAY, TLS_STATUS_CONFIG, UNKNOWN_ERROR_CONFIG } from '../constants/tlsStatus';

function isCertificateExpired(tlsCertificate) {
  if (!tlsCertificate?.expires_at) {
    return false;
  }
  return new Date() >= new Date(tlsCertificate.expires_at);
}

function resolveConfig(tlsStatus, tlsCertificate, verified) {
  const statusConfig = TLS_STATUS_CONFIG[tlsStatus];

  if (isCertificateExpired(tlsCertificate)) {
    const errorConfig = statusConfig || UNKNOWN_ERROR_CONFIG;
    return {
      ...EXPIRED_DISPLAY,
      tooltip: `Certificate expired. Renewal failed: ${errorConfig.tooltip}`
    };
  }

  if (statusConfig) {
    if (tlsStatus === 'unavailable' && !verified) {
      return {
        ...statusConfig,
        tooltip: 'Verify the domain to enable a TLS certificate'
      };
    }
    return statusConfig;
  }

  if (tlsStatus) {
    return UNKNOWN_ERROR_CONFIG;
  }

  return null;
}

export default function TlsStatusBadge({ tlsStatus, tlsCertificate, verified }) {
  const tooltipId = useUniqueId('tls-status');
  const config = resolveConfig(tlsStatus, tlsCertificate, verified);

  if (!config) {
    return null;
  }

  const Icon = config.icon;

  return (
    <Tooltip content={config.tooltip} id={tooltipId} dark>
      <Tag color={config.color}>
        <Icon size={15} />
        <span> {config.label}</span>
      </Tag>
    </Tooltip>
  );
}
